module.exports = __webpack_public_path__ + "img/20.fad79dd7.png";